module.exports = __webpack_public_path__ + "media/night/113-e36cb952.svg";